module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-technicians/master-technicians.component.scss
// module id = ./src/app/master/master-technicians/master-technicians.component.scss
// module chunks = main